import { Controller } from "@hotwired/stimulus"

// Drops the bar out of the way while the on-screen keyboard is open. The page
// uses interactive-widget=resizes-content, so a fixed bottom bar would otherwise
// sit on the visual viewport, just above the keys, and cover the field in use.
export default class extends Controller {
  connect() {
    this.onViewport = this.onViewport.bind(this)
    this.viewport = window.visualViewport
    this.viewport?.addEventListener("resize", this.onViewport)
    this.viewport?.addEventListener("scroll", this.onViewport)
  }

  disconnect() {
    this.viewport?.removeEventListener("resize", this.onViewport)
    this.viewport?.removeEventListener("scroll", this.onViewport)
  }

  onViewport() {
    const viewport = this.viewport
    if (!viewport) return

    const keyboardOpen = window.innerHeight - viewport.height - viewport.offsetTop > 140
    this.element.classList.toggle("is-keyboard-open", keyboardOpen)
  }
}
